import { BankwireHelper } from "app/helpers/bankwireHelper";
import { useState } from "react";
import type { IntlShape } from "react-intl";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import * as bankWireAPI from "../../../../api/bankWireApi";
import type { UserType } from "../../../../types/userType";
import { AcceptedBankwireCurrencies } from "../../../../utils/const";
import FormSubmittedScreen from "../FormSubmittedScreen/FormSubmittedScreen";
import "./BankWireFundingScreenDesktop.scss";
import "./BankWireFundingScreenMobile.scss";
import BankDetailsDeposit from "./components/BankDetailsDeposit/BankDetailsDeposit";
import BankDetailsForm from "./components/BankDetailsForm/BankDetailsForm";
import Withdrawal from "./components/BankDetailsWithdraw/components/Withdrawal";
import BankWireFundingScreenHeader from "./components/BankWireFundingScreenHeader/BankWireFundingScreenHeader";

export const TabTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

function BankTransferFundingScreen(props: { intl: IntlShape; user: UserType }) {
  const history = useHistory();
  const { user, intl } = props;
  const [tab, setTabValue] = useState(TabTypes.DEPOSIT);
  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [comments, setComments] = useState("");

  const [otherError, setOtherError] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);

  const deposit = (e: any) => {
    e.preventDefault();
    setFormSubmitted(true);
    bankWireAPI
      .depositFunds(amount, comments)
      .then(resp => {
        setFormSubmitted(false);
        setSuccess(true);
      })
      .catch(error => {
        const errorData = error.response.data.errors;
        handleErrors(errorData);
        setFormSubmitted(false);
      });
  };

  const handleChange = (id: string, value: string) => {
    console.log("handleChange", id, value);
    // disadvantage of hooks :(
    if (id === "amount") {
      setAmount(value);
    }
    if (id === "comments") {
      setComments(value);
    }
  };

  const handleErrors = (errorData: any[]) => {
    let amountError = "";

    let otherError = "";

    if (errorData.length > 0) {
      errorData.forEach(error => {
        if (error.messages) {
          if (error.field === "amount") {
            amountError = error.messages[0];
          } else if (error.field === "name") {
            nameError = error.messages[0];
          } else if (error.field === "bankName") {
            bankNameError = error.messages[0];
          } else if (error.field === "iban") {
            accountNoError = error.messages[0];
          } else if (error.field === "swiftCode") {
            swiftCodeError = error.messages[0];
          } else if (error.field === "bankAddress") {
            bankAddressError = error.messages[0];
          } else if (error.field === "iban") {
            ibanError = error.messages[0];
          } else if (error.field === "bankCountry") {
            bankCountryError = error.messages[0];
          } else if (error.field === "intermediateBankName") {
            bankNameInterError = error.messages[0];
          } else if (error.field === "intermediateIban") {
            accountNoInterError = error.messages[0];
          } else if (error.field === "intermediateSwiftCode") {
            swiftCodeInterError = error.messages[0];
          } else if (error.field === "intermediateBankAddress") {
            bankAddressInterError = error.messages[0];
          } else if (error.field === "intermediateBankCity") {
            bankCityInterError = error.messages[0];
          } else if (error.field === "intermediateBankCountry") {
            bankCountryInterError = error.messages[0];
          } else {
            otherError = error.messages[0];
          }
        } else if (error.detail) {
          otherError = error.detail;
        }
      });
    }

    setAmountError(amountError);
    setOtherError(otherError);
  };

  const setTab = (tabType: string) => {
    if (tab === tabType) {
      return null;
    }
    setTabValue(tabType);
    setAmountError("");
    setOtherError("");
  };

  const getTabs = () => {
    return [
      {
        title: intl.formatMessage({
          id: "cashier-deposit",
        }),
        callback: () => setTab(TabTypes.DEPOSIT),
        isActive: tab === TabTypes.DEPOSIT,
        id: "cashier-deposit",
      },
      {
        //translate titles
        title: intl.formatMessage({
          id: "cashier-withdraw",
        }),
        callback: () => setTab(TabTypes.WITHDRAW),
        isActive: tab === TabTypes.WITHDRAW,
        id: "cashier-withdraw",
      },
    ];
  };

  const newTransaction = () => {
    setFormSubmitted(false);
    setSuccess(false);
  };

  const I18n = BankwireHelper.bankwireTranslations();

  let form: JSX.Element | null = null;
  const currencyIsValid =
    AcceptedBankwireCurrencies.indexOf(user["currencyCode"]) > -1;

  switch (tab) {
    case TabTypes.DEPOSIT:
      form = (
        <BankDetailsDeposit
          I18n={I18n}
          history={history}
          user={user}
          currencyIsValid={currencyIsValid}
          intl={intl}
          deposit={deposit}
          handleChange={handleChange}
          formSubmitted={formSubmitted}
          otherError={otherError}
          amountError={amountError}
        />
      );
      break;

    case TabTypes.WITHDRAW:
      form = <Withdrawal I18n={I18n} setSuccess={setSuccess} />;
      break;

    default:
      form = (
        <BankDetailsForm
          deposit={deposit}
          I18n={I18n}
          handleChange={handleChange}
          tab={tab}
          TabTypes={TabTypes}
        />
      );
      break;
  }

  return !success ? (
    <div className="bank-wire-funding">
      <BankWireFundingScreenHeader getTabs={getTabs} history={history} />
      <div className="bank-wire-funding__content">{form}</div>
    </div>
  ) : (
    <FormSubmittedScreen
      user={user}
      verified={user["verifiedStatus"]}
      selectedTab={tab}
      newTransaction={history.goBack}
    />
  );
}

export default injectIntl(BankTransferFundingScreen);
